import { Effect } from 'effect'
import { Clipboard, Snackbar } from '~/effects'

export function copyTextToClipboard(text: string, successMessage: string) {
  return Effect.gen(function* () {
    const clipboard = yield* Clipboard
    const snackbar = yield* Snackbar
    const copied = yield* clipboard.copy(text).pipe(
      Effect.as(true),
      Effect.catchTags({
        'ClipboardError.Unavailable': () => Effect.succeed(false),
        'ClipboardError.WriteFailed': () => Effect.succeed(false)
      })
    )

    if (copied) {
      yield* snackbar.show(successMessage)
    } else {
      yield* snackbar.show('Failed to copy to clipboard', { variant: 'error' })
    }
    return null
  })
}
